<template>
  <transition name="pop">
    <div class="popup" v-if="show" :class="{hide: hide}">
      <div v-if="!hide" class="popup_content flex column content align-center">
        <div class="flex column actions justify-center align-center">
         <component v-if="component" :is="component" v-bind="componentData"></component>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      hide: false,
      component: null,
      componentData: null,
    };
  },
  computed: {
    show() {
      return !!this.component;
    }
  },
  methods: {
    fake() {
      this.component = null;
      this.componentData = null;
      this.$root.popUpShown = false;
      document.querySelector("body").classList.remove("modal-open");
    },
    run(func) {
      if (this.popData.hideViewOnAction) this.hide = true;
      else this.fake();
      func()
    }
  },
  created() {
    this.$root.$on("popup", async k => {
      if (k.component) this.component = k.component;
      if (!this.component) return;
      this.componentData = k.componentData;
      this.$root.popUpShown = true;
      document.querySelector("body").classList.add("modal-open");
    });
    this.$root.$on("hidePopup", this.fake);
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.popup {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100vw;
  z-index: 99;
  height: 100dvh;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  &.hide {
    background-color: #FFFFFF;
    @media (prefers-color-scheme: dark) {
      background-color: #000000;
    }
  }
  @media (prefers-color-scheme: dark) {
    background-color: rgba(0, 0, 0, 0.8);
    //color: #EEEEEE;
  }
   --webkit-backdrop-filter: blur(20px) saturate(2);
  .content {
      .btn {
          margin-bottom: 1em;
      }
  }
  @media screen and (max-width: 768px) {
              background-color: rgba(0,0,0,.8);
  }
  .popup_content {
    .box {
      min-width: 600px;
    }
    @media screen and (max-width: 768px) {
        position: fixed;
        width: 100vw;
        bottom:0;
        top:auto;
        height: auto;

        .box {
            margin:0;
            width: 100vw;
            min-width: 0;
            max-width: 100vw;
            height: 95dvh;
            box-shadow: 0px -10px 25px rgba(0,0,0,.1);
            overflow: auto;
            background-color: white!important;
            border-radius: 15px 15px 0 0;
            position: relative;
        }
    }
  }
  
}

@keyframes zoom {
    from {
        transform: scale(1.3);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}
</style>
<style lang="scss">
.pop-enter-active,
.pop-leave-active {
  transition: .2s cubic-bezier(0.19, 1, 0.22, 1);
  .box {
    transition: .5s cubic-bezier(0.19, 1, 0.22, 1);
  }
}
.pop-enter, .pop-leave-to /* .fade-leave-active below version 2.1.8 */ {
  @media screen and (min-width:769px) {
    transform: scale(1.1);
  }
    opacity: 0;
    .box {
      @media screen and (max-width: 768px) {
        transform: translateY(100%);
      }
    }
}
</style>
